import { BaseObject } from "@adgate/common/types/base-object.type";

export class Action extends BaseObject
{
    public static CANCEL: Action        = {id:98,description:"Cancel",messageDescription:"Issued a cancel"};
    public static FORCESTATUS: Action   = {id:99,description:"Force Status",messageDescription:"Forced status change"};

    public static APPROVE: Action       = {id:1,description:"Approve",messageDescription:"Issued an Approve"};
    public static REJECT: Action        = {id:2,description:"Reject",messageDescription:"Issued a Reject"};
    public static REVIEW: Action        = {id:3,description:"Review",messageDescription:"Issued a Review"};
    public static RELEASE: Action       = {id:5,description:"Release",messageDescription:"Issued a Release"};
    public static RETRYDOWNLOAD: Action = {id:6,description:"Retry",messageDescription:"Retried media download"};
    public static CLOSE: Action         = {id:8,description:"Close",messageDescription:"Closed report"};
    public static ARCHIVE: Action       = {id:9,description:"Archive",messageDescription:"Archived report"};

    messageDescription!: string;
}